import { render, staticRenderFns } from "./BlockCarousel.vue?vue&type=template&id=08acea13&"
import script from "./BlockCarousel.vue?vue&type=script&lang=js&"
export * from "./BlockCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports